export function getRetention(impactEnergy) {
  let retentionLevel;
  if (impactEnergy < 190) {
    retentionLevel = 1
  } else if (impactEnergy <= 250) {
      retentionLevel = 2
  } else if (impactEnergy <= 300) {
      retentionLevel = 3
  } else if (impactEnergy <= 350) {
      retentionLevel = 4
  } else if (impactEnergy <= 400) {
      retentionLevel = 5
  } else if (impactEnergy <= 450) {
      retentionLevel = 6
  } else if (impactEnergy <= 450) {
      retentionLevel = 7
  } else if (impactEnergy <= 500) {
      retentionLevel = 8
  } else if (impactEnergy <= 550) {
      retentionLevel = 9
  } else if (impactEnergy <= 600) {
      retentionLevel = 10
  } else {
    retentionLevel = 0;
  }
  return retentionLevel;
}

export function getTitleRetention(stat) {
  let statTitle;
  if (stat < 190) {
    statTitle = 'У1';
  } else if (stat < 250) {
    statTitle = 'У2';
  } else if (stat < 300) {
    statTitle = 'У3';
  } else if (stat < 350) {
    statTitle = 'У4';
  } else if (stat < 400) {
    statTitle = 'У5';
  } else if (stat < 450) {
    statTitle = 'У6';
  } else if (stat < 450) {
    statTitle = 'У7';
  } else if (stat < 500) {
    statTitle = 'У8';
  } else if (stat < 550) {
    statTitle = 'У9';
  } else if (stat < 600) {
    statTitle = 'У10';
  } else {
    statTitle = '';
  };
  return statTitle;
}



// WEBPACK FOOTER //
// ./src/components/constants.js